import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useReminder } from '../../contexts/ReminderContext';
import Colors from '../../utils/color';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  // Reminder section: heading + inner white card. Transparent — the grey card
  // backdrop is the shared left-pane card (MainPageLayout).
  section: {
    flexShrink: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0.75),
    minWidth: 0,
  },
  headerIcon: {
    color: Colors.torchRed,
    fontSize: '1rem',
    flexShrink: 0,
  },
  title: {
    color: Colors.readBack,
    fontWeight: 700,
    fontSize: '0.8rem',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  innerCard: {
    boxSizing: 'border-box',
    minWidth: 0,
    backgroundColor: Colors.white,
    border: `${spacing(0.125)} solid ${Colors.alto}`,
    borderRadius: spacing(1),
    padding: spacing(1),
    fontSize: '0.8rem',
    color: Colors.mineShaft,
    // Wrap long messages / unbreakable tokens instead of overflowing.
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));

/**
 * REMINDER (left pane, below the transcript). Card-styled twin of
 * LiveTranscriptCard that surfaces the slash-command reminder message.
 * Hidden when there's no active reminder.
 */
const ReminderCard = () => {
  const classes = useStyles();
  const { reminderMessage, isVisible } = useReminder();

  if (!isVisible) {
    return null;
  }

  return (
    <div className={classes.section}>
      <div className={classes.header}>
        <WarningAmberOutlinedIcon className={classes.headerIcon} />
        <span className={classes.title}>Reminder</span>
      </div>
      <div className={classes.innerCard}>{reminderMessage}</div>
    </div>
  );
};

export default ReminderCard;
